module.exports = __webpack_public_path__ + "static/Q3_2022_Investor_Presentation-4728918f279c4f6d50fbb6e6d270eb0e.pdf";